import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchFields: {
    programId: "",
    userId: "",
    customerName: "",
    description: "",
    createdDate: "",
  },
  typesList: [],
  categoriesList: [],
  productsList: [],
  laborCodesList: [],
  programTableList: [],
  storeNumberList: [],
  laborCodeOptions: [],
  searchFilterValue: "",
  showProgramSearchTable: false,
  lineItemsList: [],
  categoriesData: [],
  lineItemPricesData: [],
  userData: {},
};

const programBuilder = createSlice({
  name: "programBuilder",
  initialState,
  reducers: {
    resetState() {
      return initialState;
    },
    getCategoriesList(state, action) {
      state.categoriesList = action.payload;
    },
    getProductsList(state, action) {
      state.productsList = action.payload;
    },
    getLaborCodesList(state, action) {
      state.laborCodesList = action.payload;
    },
    getLaborCodeOptions(state, action) {
      state.laborCodeOptions = action.payload;
    },
    clearLookupData(state) {
      state.categoriesList = initialState.categoriesList;
      state.productsList = initialState.productsList;
      state.laborCodesList = initialState.laborCodesList;
    },
    updateSearchFilterValue(state, action) {
      state.searchFilterValue = action.payload;
    },
    clearProgSearchData(state) {
      state.showProgramSearchTable = initialState.showProgramSearchTable;
    },
    programSearchSubmitSuccess(state, action) {
      state.showProgramSearchTable = true;
      state.programTableList = action.payload;
    },
    getStoresNoList(state, action) {
      state.storeNumberList = action.payload;
    },
    addLineItems(state, action) {
      const tempLineItems = JSON.parse(JSON.stringify(state.lineItemsList));
      tempLineItems.push(action.payload);
      state.lineItemsList = tempLineItems;
    },
    getLineItemsData(state, action) {
      state.lineItemsList = action.payload;
    },
    addCategory(state, action) {
      const tempCategoriesData = JSON.parse(JSON.stringify(state.categoriesData));
      tempCategoriesData.push(action.payload);
      tempCategoriesData?.sort((a, b) => a.categoryName?.localeCompare(b.categoryName)) || [];
      state.categoriesData = tempCategoriesData;
    },
    getCategoriesData(state, action) {
      const tempCategoriesData = action.payload?.sort((a, b) => a.categoryName?.localeCompare(b.categoryName)) || [];
      state.categoriesData = tempCategoriesData;
    },
    getProgramDetails(state, action) {
      state.programDetailsData = action.payload;
    },
    updateProgramDetails(state, action) {
      state.programDetailsData = action.payload;
    },
    getLineItemPrices(state, action) {
      state.lineItemPricesData = action.payload;
    },
    addLineItemPrices(state, action) {
      const priceMap = new Map(state.lineItemPricesData.map((item) => [item.lineItemPriceId, item]));

      action.payload.forEach((newPriceObj) => {
        priceMap.set(newPriceObj.lineItemPriceId, {
          ...priceMap.get(newPriceObj.lineItemPriceId),
          ...newPriceObj,
        });
      });

      state.lineItemPricesData = Array.from(priceMap.values());
    },
    updateLineItemData(state, action) {
      const tempLineItemList = JSON.parse(JSON.stringify(state.lineItemsList));
      const existingRecord = tempLineItemList.find((obj) => obj.lineItemId == action.payload.lineItemId);
      if (existingRecord) {
        existingRecord.name = action.payload.name;
        existingRecord.unitOfMeasurement = action.payload.unitOfMeasurement;
      } else tempLineItemList.push(action.payload);
      state.lineItemsList = tempLineItemList;
    },
    deleteLineItemData(state, action) {
      const tempLineItemList = JSON.parse(JSON.stringify(state.lineItemsList));
      const updatedLineItemList = tempLineItemList.filter((obj) => obj.lineItemId != action.payload);
      state.lineItemsList = updatedLineItemList;
    },
    deleteProductData(state, action) {
      const tempCategoriesData =
        JSON.parse(JSON.stringify(state.categoriesData))?.sort((a, b) =>
          a.categoryName?.localeCompare(b.categoryName),
        ) || [];
      const updatedCategoriesData = tempCategoriesData.filter((obj) => obj.productId != action.payload);
      state.categoriesData = updatedCategoriesData;
    },
  },
});

export const {
  resetState,
  getUserData,
  getCategoriesList,
  getProductsList,
  getLaborCodesList,
  getLaborCodeOptions,
  clearLookupData,
  updateSearchFilterValue,
  clearProgSearchData,
  programSearchSubmitSuccess,
  getStoresNoList,
  addLineItems,
  getLineItemsData,
  addCategory,
  getCategoriesData,
  getProgramDetails,
  updateProgramDetails,
  getLineItemPrices,
  addLineItemPrices,
  updateLineItemData,
  deleteLineItemData,
  deleteProductData,
} = programBuilder.actions;

export default programBuilder.reducer;
